import { createSlice } from "@reduxjs/toolkit";

import { Executor } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { Orders } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	executors: [],
	parkingsSubscribeData: null,
};

const setParkingsDataToExecutors: ReduxReducer<State, Executor.Model[]> = (
	state,
	action,
) => {
	state.executors = action.payload;
};

const setParkingsSubscribeData: ReduxReducer<State, any> = (state, action) => {
	state.parkingsSubscribeData = action.payload;
};

const orderParkingData = createSlice({
	name: Orders.ConstantOrdersSlice.PARKING_DATA,
	initialState,
	reducers: {
		setParkingsDataToExecutors,
		setParkingsSubscribeData,
	},
});

export const orderParkingDataAction = orderParkingData.actions;
export const orderParkingDataReducer = orderParkingData.reducer;
export type orderParkingDataState = State;

export default orderParkingData;
